import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import WaitView from "../views/WaitView.vue";
import FinishView from "../views/FinishView.vue";
import DoneView from "../views/DoneView.vue";
import FormView from "../views/FormView.vue";
import MentionsView from "../views/MentionsView.vue";
import ContactView from "../views/ContactView.vue";
import CloseView from "../views/CloseView.vue";
import LaterView from "../views/LaterView.vue";
import lineitemView from "../views/LineItemView.vue";
import updateView from "@/views/updateView.vue";
import missingView from "@/views/MissingView.vue";
import Form2View from "@/views/Form2View.vue";
import FormTestView from "@/views/FormTest.vue";
import TestView from "@/views/TestView.vue";
import waitView from "@/views/WaitView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home2",
    component: waitView,
    // component: WaitView,
  },
  {
    path: "/home",
    name: "home",
    component: HomeView,
    // component: WaitView,
  },
  {
    path: "/update",
    name: "update",
    component: updateView,
  },
  {
    path: "/update/:_id/:uid",
    name: "update2",
    component: updateView,
  },
  {
    path: "/missing/:_id/:uid",
    name: "missing",
    component: missingView,
  },
  {
    path: "/later",
    name: "later",
    component: LaterView,
  },
  {
    path: "/wait",
    name: "wait",
    component: WaitView,
  },
  {
    path: "/finish",
    name: "finish",
    component: FinishView,
  },
  {
    path: "/mentions",
    name: "mentions",
    component: MentionsView,
  },
  {
    path: "/done",
    name: "done",
    component: DoneView,
  },
  {
    path: "/close",
    name: "close",
    component: CloseView,
  },
  {
    path: "/form",
    name: "form",
    component: FormView,
  },
  {
    path: "/formtest",
    name: "formtest",
    component: FormTestView,
  },
  {
    path: "/form2",
    name: "form2",
    component: Form2View,
  },
  {
    path: "/lineitem/:_id/:uid",
    alias: "/status/:_id/:uid",
    name: "lineitem",
    component: lineitemView,
  },
  {
    path: "/contact",
    name: "contact",
    component: ContactView,
  },
  {
    path: "/test",
    name: "test",
    component: TestView,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// Redirection basée sur la date
router.beforeEach((to, from, next) => {
  const launchDate = new Date('2025-11-01T00:00:00');
  const now = new Date();

  // Si on est avant le 01/11/2025 minuit et qu'on essaie d'accéder à home
  if (now < launchDate && to.path === '/home') {
    next({ path: '/', query: to.query });
  }
  // Si on est après le 01/11/2025 minuit et qu'on est sur la page wait (/)
  else if (now >= launchDate && to.path === '/') {
    next({ path: '/home', query: to.query });
  }
  else {
    next();
  }
});

export default router;
